import type * as Types from '../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type MessageDraftsListByEventQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
}>;

export type MessageDraftsListByEventQuery = {
  __typename?: 'Query';
  messageDraftsByEvent: Array<{
    __typename?: 'MessageDraft';
    id: string;
    channel: Types.MessageDraftChannel;
    messageType?: string | null;
    messageBatchId: string;
    displayLabel: string;
    status: Types.MessageDraftStatus;
    scheduledAt?: any | null;
    updatedAt: any;
    failureCode?: Types.MessageDraftFailureCode | null;
    failureReason?: string | null;
    recipientType: Types.MessageDraftRecipientType;
    recipientIds: Array<string>;
    smartRule?: { __typename?: 'SmartTagRule'; version: number; resolver: string; params: any } | null;
  }>;
};

export const MessageDraftsListByEventDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MessageDraftsListByEvent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'messageDraftsByEvent' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'messageType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'messageBatchId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayLabel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduledAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'failureCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'failureReason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'recipientType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'recipientIds' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'smartRule' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'resolver' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'params' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useMessageDraftsListByEventQuery__
 *
 * To run a query within a React component, call `useMessageDraftsListByEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageDraftsListByEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageDraftsListByEventQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useMessageDraftsListByEventQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MessageDraftsListByEventQuery, MessageDraftsListByEventQueryVariables>) {
  return ApolloReactHooks.useQuery<MessageDraftsListByEventQuery, MessageDraftsListByEventQueryVariables>(MessageDraftsListByEventDocument, baseOptions);
}
export function useMessageDraftsListByEventLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MessageDraftsListByEventQuery, MessageDraftsListByEventQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<MessageDraftsListByEventQuery, MessageDraftsListByEventQueryVariables>(MessageDraftsListByEventDocument, baseOptions);
}
export type MessageDraftsListByEventQueryHookResult = ReturnType<typeof useMessageDraftsListByEventQuery>;
export type MessageDraftsListByEventLazyQueryHookResult = ReturnType<typeof useMessageDraftsListByEventLazyQuery>;
export type MessageDraftsListByEventQueryResult = Apollo.QueryResult<MessageDraftsListByEventQuery, MessageDraftsListByEventQueryVariables>;
